import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';
import AutomaticRepliesOptionState from '../data/store/schema/AutomaticRepliesOptionState';
import getAutomaticRepliesOptionStateDefaultValue from './getAutomaticRepliesOptionStateDefaultValue';
import OofState from 'owa-service/lib/contract/OofState';
import ExternalAudience from 'owa-service/lib/contract/ExternalAudience';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { userDate } from 'owa-datetime/lib/userDate';

/**
 * Utility function to parse mailbox auto reply configuration options
 * @returns state of type AutomaticRepliesOptionState
 */
export default function parseMailboxAutoReplyConfiguration(
    mailboxAutoReplyConfigurationOptions: MailboxAutoReplyConfigurationOptions
): AutomaticRepliesOptionState {
    let optionState: AutomaticRepliesOptionState = getAutomaticRepliesOptionStateDefaultValue();

    optionState.isAutomaticReplyEnabled =
        mailboxAutoReplyConfigurationOptions.AutoReplyState === OofState.Enabled ||
        mailboxAutoReplyConfigurationOptions.AutoReplyState === OofState.Scheduled;

    optionState.periodicReplyEnabled =
        mailboxAutoReplyConfigurationOptions.AutoReplyState === OofState.Scheduled;

    optionState.blockCalendarEnabled = mailboxAutoReplyConfigurationOptions.CreateOOFEvent;

    optionState.blockCalendarTitle = mailboxAutoReplyConfigurationOptions.OOFEventSubject;

    optionState.declineNewInvitationsEnabled =
        mailboxAutoReplyConfigurationOptions.AutoDeclineFutureRequestsWhenOOF;

    optionState.declineExistingCalendarEventsEnabled =
        mailboxAutoReplyConfigurationOptions.DeclineEventsForScheduledOOF;

    optionState.sendRepliesToContactsOnlyEnabled =
        mailboxAutoReplyConfigurationOptions.ExternalAudience === ExternalAudience.Known;

    optionState.sendRepliesOutsideOrgEnabled =
        mailboxAutoReplyConfigurationOptions.ExternalAudience === ExternalAudience.Known ||
        mailboxAutoReplyConfigurationOptions.ExternalAudience === ExternalAudience.All;

    let isEnterpriseUser = !isConsumer();
    if (isEnterpriseUser) {
        optionState.editorViewStateMessage = createEditorViewState(
            mailboxAutoReplyConfigurationOptions.InternalMessage,
            false
        );
        optionState.editorViewStateOutsideOrg = createEditorViewState(
            mailboxAutoReplyConfigurationOptions.ExternalMessage,
            false
        );
    } else {
        optionState.editorViewStateMessage = createEditorViewState(
            mailboxAutoReplyConfigurationOptions.ExternalMessage,
            false
        );
    }

    // Check condition if the value can be null or empty string
    optionState.startDate = userDate(mailboxAutoReplyConfigurationOptions.StartTime);
    optionState.endDate = userDate(mailboxAutoReplyConfigurationOptions.EndTime);

    return optionState;
}
